// extracted by mini-css-extract-plugin
module.exports = {"AdSlot":"pe_a pz_a pz_j pz_q"};